import axios from 'axios';  
  
const service = axios.create({  
  baseURL: 'https://openapi.ztnews.net/qjnews/', // 基础URL  
  timeout: 5000 // 请求超时时间  
});  
  
// 请求拦截器  
service.interceptors.request.use(  
  config => {  
    // 给post请求添加头值get请求不需要头值 
    if (config.method === 'post') {  
      let websiteInfoString = localStorage.getItem('websiteInfo');  
      let websiteInfo;  
      try {  
        websiteInfo = JSON.parse(websiteInfoString);  
      } catch (error) {  
        // 解析失败，'websiteInfo'不是一个有效的JSON字符串，或者它根本不存在  
        websiteInfo = null;  
      }  
        
      if (websiteInfo === null) { 
        axios.get('https://openapi.ztnews.net/qjnews/websiteInfo') 
        .then(response => { 
            //console.log(response.data)
            localStorage.setItem('websiteInfo',JSON.stringify(response.data));
        })  
        .catch(error => {  
            // 处理错误信息  
            console.log(error);
        });      
      }
      const parsedInfo = JSON.parse(localStorage.getItem('websiteInfo'));  
      //console.log(parsedInfo.token,parsedInfo.wps)
      if (parsedInfo) {  
        config.headers['Authorization'] = parsedInfo.token;  
        config.headers['Wps'] = parsedInfo.wps;
      }  
    }  
    return config;  
  },  
  error => {  
    // 对请求错误做些什么  
    return Promise.reject(error);  
  }  
);  
  
// 响应拦截器  
service.interceptors.response.use(  
  response => {  
    return response.data;  
  },  
  error => {  
    // 如果是401错误
    if (error.response && error.response.status === 401) {  
      console.log(error.response)
      // 发起请求获取新的token 
      return axios.get('https://openapi.ztnews.net/qjnews/websiteInfo')  
        .then(response => {  
          //console.log(response.data)
          localStorage.setItem('websiteInfo', JSON.stringify(response.data));  
          const parsedInfo = JSON.parse(localStorage.getItem('websiteInfo'));  
            
          // 假设原始请求的config被保存在error对象中，这里需要根据实际情况调整  
          const originalRequestConfig = error.config;  
            
          // 在headers中添加新的token和wps  
          originalRequestConfig.headers['Authorization'] = parsedInfo.token;  
          originalRequestConfig.headers['Wps'] = parsedInfo.wps;  
            
          // 重新发起POST请求  
          return service(originalRequestConfig);  
        })  
        .catch(getErrorCode => {  
          console.error('获取token失败:', getErrorCode);  
          // 处理获取token失败的情况  
          return Promise.reject(error);  
        });  
    }  
    //console.log(error.response.data)
    // 对于非401错误直接返回错误  
    return Promise.reject(error);  
  }  
);  
  
// 封装post请求  
export function post(url, data = {}) {  
  return service({  
    method: 'post',  
    url,  
    data  
  });  
}